import {
  IconBell,
  IconBellGray,
  IconBinocularsGray,
  IconChainLink,
  IconChainLinkGray,
  IconChartBarGray,
  IconChartRadius,
  IconClockGray,
  IconCloudCheckGray,
  IconDashboard,
  IconRoute,
  IconRulerGray,
  IconSearch,
  IconSecurity,
  IconShareGray,
  IconTagGray,
  IconTvocGray,
  IconUserCheck,
  IconWarning,
  IconWarningGray,
  IconZoneGray,
} from '@assets/images/icon';
import { IconTemp } from '@assets/images/main';
import { rtlsSystem } from '@assets/images/solution';
import video from '@src/assets/images/solution/constructionAsset/video/rtlsVideo.mp4';

import image1 from '@src/assets/images/solution/cityDigital/img/1.avif';
import image2 from '@src/assets/images/solution/cityDigital/img/2.avif';
import image3 from '@src/assets/images/solution/cityDigital/img/3.avif';
import image4 from '@src/assets/images/solution/cityDigital/img/4.avif';
import image5 from '@src/assets/images/solution/cityDigital/img/5.avif';
import image6 from '@src/assets/images/solution/cityDigital/img/6.avif';
import image7 from '@src/assets/images/solution/cityDigital/img/7.avif';
import image8 from '@src/assets/images/solution/cityDigital/img/8.avif';

export default {
  type: 'Giải pháp thành phố',

  banner: {
    title: 'Giám sát toàn thành phố theo thời gian thực, hệ thống ứng phó thảm họa số',
    desc: 'Triển khai dữ liệu không gian đô thị bằng mô hình số hóa 3D (Digital Twin), cho phép dự đoán, ứng phó và phục hồi toàn diện trước và sau thảm họa trên một nền tảng duy nhất.',
  },

  video: {
    title: 'Kết nối toàn bộ quy trình quản lý thảm họa theo thời gian thực với Digital Twin',
    desc: 'Mô phỏng thành phố thực tế trong không gian ảo, đồng thời phản ánh dữ liệu cảm biến, dữ liệu vị trí, hình ảnh camera,... theo thời gian thực để vận hành hệ thống cảnh báo sớm, ứng phó khi xảy ra và phục hồi sau thảm họa.',
    play: video,
  },

  func: [
    {
      theme: 'Tích hợp thông tin thảm họa đô thị & trực quan hóa thời gian thực',
      title: 'Giám sát tích hợp dựa trên hạ tầng đô thị',
      desc: 'Quản lý toàn bộ dữ liệu hạ tầng cần thiết cho ứng phó thảm họa trên một nền tảng. Kết hợp dữ liệu đường bộ, sông ngòi, công trình, cảm biến để giám sát các yếu tố rủi ro trên toàn thành phố theo thời gian thực.',
      sub1: 'Giám sát trạng thái thời gian thực',
      icon1: IconClockGray,
      sub2: 'Kết nối dữ liệu nhanh',
      icon2: IconShareGray,
      image: image1,
    },
    {
      title: 'Thu thập & phân tích dữ liệu thời tiết theo thời gian thực',
      desc: 'Thu thập hình ảnh vệ tinh, bản đồ thời tiết, dữ liệu radar theo thời gian thực, đồng thời cung cấp hệ thống dự báo và cảnh báo tình huống thời tiết cực đoan. Số hóa môi trường thời tiết đô thị để ứng dụng cho các kịch bản ứng phó.',
      sub1: 'Định danh tài sản rủi ro',
      icon1: IconWarningGray,
      sub2: 'Lưu trữ dữ liệu đám mây',
      icon2: IconCloudCheckGray,
      image: image2,
    },
    {
      title: 'Theo dõi lượng mưa theo khu vực theo thời gian thực',
      desc: 'Thu thập và phân tích trạng thái lượng mưa theo khu vực bằng các thiết bị đo lượng mưa được lắp đặt trong thành phố. Hỗ trợ đưa ra quyết định ưu tiên ứng phó tại các khu vực bị ảnh hưởng khi có mưa lớn.',
      sub1: 'Cung cấp dữ liệu thống kê',
      icon1: IconChartBarGray,
      sub2: 'Lưu trữ dữ liệu đám mây',
      icon2: IconCloudCheckGray,
      image: image3,
    },
    {
      title: 'Trực quan hóa mực nước & lưu lượng sông',
      desc: 'Trực quan hóa mực nước, lưu lượng, trạng thái cống của các con sông chính như sông Nakdong, sông Naeseongcheon theo thời gian thực. Tự động phát hiện mực nước bất thường và gửi cảnh báo rủi ro.',
      sub1: 'Cung cấp dữ liệu thống kê',
      icon1: IconChartBarGray,
      sub2: 'Lưu trữ dữ liệu đám mây',
      icon2: IconCloudCheckGray,
      image: image4,
    },
    {
      theme: 'Tự động hóa ứng phó thảm họa & sử dụng phòng tình huống',
      title: 'Liên kết cảnh báo theo tình huống tổng hợp',
      desc: 'Tổng hợp nhiều dữ liệu khác nhau, hiển thị rủi ro rõ ràng trên màn hình phòng điều khiển. Tự động thực hiện cảnh báo và kích hoạt phản ứng theo tiêu chí quyết định tùy theo tình huống.',
      sub1: 'Cung cấp dữ liệu thống kê',
      icon1: IconChartBarGray,
      sub2: 'Lưu trữ dữ liệu đám mây',
      icon2: IconCloudCheckGray,
      image: image5,
    },
    {
      title: 'Cấu hình & hiển thị màn hình phòng tình huống theo thời gian thực',
      desc: 'Phòng tình huống thảm họa tổng hợp hiển thị CCTV, lịch sử cảnh báo, mực nước sông chính trên màn hình lớn theo bố cục chia sẻ để giám sát trực tiếp. Cấu hình riêng biệt giúp nâng cao năng lực phản ứng tại chỗ & chia sẻ nhanh tình hình thảm họa.',
      sub1: 'Cung cấp dữ liệu thống kê',
      icon1: IconChartBarGray,
      sub2: 'Lưu trữ dữ liệu đám mây',
      icon2: IconCloudCheckGray,
      image: image6,
    },
    {
      title: 'Hệ thống ứng phó từ xa khi xảy ra thảm họa',
      desc: 'Khi xảy ra thảm họa, có thể thực hiện hành động kịp thời từ xa như phát thông báo qua TTS, gửi tin nhắn, giám sát CCTV, điều khiển cầu dao từ xa.',
      sub1: 'Cung cấp dữ liệu thống kê',
      icon1: IconChartBarGray,
      sub2: 'Lưu trữ dữ liệu đám mây',
      icon2: IconCloudCheckGray,
      image: image7,
    },
    {
      title: 'Trực quan hóa dữ liệu đa bảng',
      desc: 'Cung cấp bảng dữ liệu tích hợp thông tin thời tiết, mực nước, lượng mưa, chỉ số cảnh báo. So sánh và đánh giá thông tin môi trường trực quan trên một màn hình, giúp nhận diện tình huống và ra quyết định nhanh hơn.',
      sub1: 'Cung cấp dữ liệu thống kê',
      icon1: IconChartBarGray,
      sub2: 'Lưu trữ dữ liệu đám mây',
      icon2: IconCloudCheckGray,
      image: image8,
    },
  ],

  subfunc: {
    title: 'Nhiều tính năng khác',
    desc: 'Chất thải y tế cần được quản lý cẩn trọng tuyệt đối. Một chút lơ là hay sai sót nhỏ cũng có thể dẫn đến tai nạn y tế nghiêm trọng. Vì vậy, cần quản lý chính xác và đảm bảo an toàn tối đa.<br/>ORBRO cung cấp nhiều tính năng để xây dựng cơ sở y tế an toàn và hiệu quả.',

    data: [
      {
        icon: IconDashboard,
        title: 'Giám sát toàn TP',
        desc: 'Quản lý hạ tầng trên 1 nền tảng.',
      },
      {
        icon: IconClockGray,
        title: 'Thu thập thời tiết',
        desc: 'Radar, vệ tinh hiển thị trực tiếp.',
      },
      {
        icon: IconChartBarGray,
        title: 'Phân tích mưa',
        desc: 'Phân tích mưa tự động theo vùng.',
      },
      {
        icon: IconChartBarGray,
        title: 'Giám sát mực nước',
        desc: 'Theo dõi sông suối trực tiếp.',
      },
      {
        icon: IconDashboard,
        title: 'Bảng tổng quan',
        desc: 'CCTV, cảm biến hiển thị chung.',
      },
      {
        icon: IconZoneGray,
        title: 'Hiển thị đa màn',
        desc: 'Chia màn hình theo mục đích.',
      },
      {
        icon: IconBell,
        title: 'Cảnh báo tự động',
        desc: 'Đạt điều kiện sẽ báo tự động.',
      },
      {
        icon: IconSecurity,
        title: 'CCTV & điều khiển',
        desc: 'Xem & điều khiển từ xa.',
      },
      {
        icon: IconRoute,
        title: 'Phản ứng kịch bản',
        desc: 'Chạy kế hoạch tự động.',
      },
      {
        icon: IconChartRadius,
        title: 'Lưu nhật ký tự động',
        desc: 'Ghi toàn bộ sự kiện.',
      },
    ],
  },

  system: {
    title: 'Cấu hình hệ thống',
    img: rtlsSystem,
  },

  productTitle: 'Cấu hình sản phẩm',
  product: [{ tag: 'assetPackage' }, { tag: 'workerPackage' }],

  contents: [{ data: 'medicalPatient' }, { data: 'officeAsset' }, { data: 'blogMedical' }, { data: 'blogRTLS' }],
};
